import { getApi } from "../../services/httpService";


export function contactUS(data){
    return getApi().post('send/mail',data);
}

